import { useLayoutEffect } from "react";
import { useTheme } from "next-themes";

/**
 * Force light mode for the duration of the calling component's lifetime.
 *
 * Sets the `light` class directly on `<html>` synchronously (via
 * useLayoutEffect) so there's no flash of the user's prior theme, then also
 * routes through next-themes' setTheme so its internal state stays in sync.
 * Restores the previous theme on unmount.
 */
export function useForceLightTheme() {
  const { theme, setTheme } = useTheme();

  useLayoutEffect(() => {
    const root = document.documentElement;
    const previousTheme = theme;
    const hadDarkClass = root.classList.contains("dark");

    root.classList.remove("dark");
    root.classList.add("light");
    root.style.colorScheme = "light";

    if (previousTheme !== "light") {
      setTheme("light");
    }

    return () => {
      if (hadDarkClass) {
        root.classList.add("dark");
        root.classList.remove("light");
        root.style.colorScheme = "dark";
      } else {
        root.style.colorScheme = "";
      }
      if (previousTheme && previousTheme !== "light") {
        setTheme(previousTheme);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
